import * as normalize from 'utils/normalize';

import getPatientName from 'utils/print/getPatientName';
import getPatientAddress from 'utils/print/getPatientAddress';
import getPatientSSN from 'utils/print/getPatientSSN';
import getPatientRecordNumber from 'utils/print/getPatientRecordNumber';
import getPatientFullDob from 'utils/print/getPatientFullDob';
import getPatientGender from 'utils/print/getPatientGender';
import getPatientFullPhone from 'utils/print/getPatientFullPhone';
import getDiagnosisCode from 'utils/print/getDiagnosisCode';
import getPrescriberName from 'utils/print/getPrescriberName';
import getPrescriberFullPhone from 'utils/print/getPrescriberFullPhone';
import getSignature from 'utils/print/getSignature';
import getBusinessName from 'utils/print/getBusinessName';
import getFacilityName from 'utils/print/getFacilityName';
import getBusinessStreet from 'utils/print/getBusinessStreet';
import getFacilityStreet from 'utils/print/getFacilityStreet';
import getBusinessCityStateZip from 'utils/print/getBusinessCityStateZip';
import getFacilityCityStateZip from 'utils/print/getFacilityCityStateZip';
import getBusinessPhone from 'utils/print/getBusinessPhone';
import getFacilityPhone from 'utils/print/getFacilityPhone';
import getBusinessFax from 'utils/print/getBusinessFax';
import getFacilityFax from 'utils/print/getFacilityFax';
import getSignatureDate from 'utils/print/getSignatureDate';

const DeliveryTicketPlanOfCareRespiratory = {
  ID: 21,
  Name: 'Plan Of Care / Respiratory',
  Type: 'Assessment Form',
  Format: 'letter',
  Orientation: 'p',
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/Delivery-Ticket-Plan-Of-Care-Respiratory/1.js',
      Logo: {
        x: 25,
        y: 20,
        width: 50,
        height: 20,
      },
      texts: [
        {
          name: 'Business Name',
          getText: props => getFacilityName(props) || getBusinessName(props),
          x: 108,
          y: 7,
          align: 'center',
          fontStyle: 'italic',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Street',
          getText: props => getFacilityStreet(props) || getBusinessStreet(props),
          x: 150,
          y: 21,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business City State Zip',
          getText: props => getFacilityCityStateZip(props) || getBusinessCityStateZip(props),
          x: 150,
          y: 24,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Phone',
          getText: props => getFacilityPhone(props) ? `Tel: ${getFacilityPhone(props)}` : `Tel: ${getBusinessPhone(props)}`,
          x: 150,
          y: 27,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Fax',
          getText: props => getFacilityFax(props) ? `Fax: ${getFacilityFax(props)}` : `Fax: ${getBusinessFax(props)}`,
          x: 150,
          y: 30,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
      ],
      fields: [
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 33,
          y: 54.5,
          width: 60,
        },
        {
          name: 'Patient Date of Birth',
          type: 'text',
          getValue: getPatientFullDob,
          x: 101.5,
          y: 54.5,
          width: 27,
          normalize: normalize.date,
        },
        {
          name: 'Patient Gender',
          getValue: getPatientGender,
          type: 'radio',
          options: [
            {
              x: 136,
              y: 55,
              width: 3,
              height: 3,
              value: 'M',
            },
            {
              x: 148.5,
              y: 55,
              width: 3,
              height: 3,
              value: 'F',
            },
          ],
        },
        {
          name: 'Date of Visit',
          type: 'text',
          x: 178,
          y: 54.5,
          width: 19,
          normalize: normalize.date,
        },
        {
          name: 'Patient Address',
          type: 'text',
          getValue: getPatientAddress,
          x: 35,
          y: 58.25,
          width: 65,
        },
        {
          name: 'Patient SS',
          type: 'text',
          getValue: getPatientSSN,
          x: 108,
          y: 58.25,
          width: 22,
        },
        {
          name: 'Adv Dir',
          type: 'checkbox',
          x: 144,
          y: 59,
          width: 3,
          height: 3,
        },
        {
          name: 'Patient Record Number',
          type: 'text',
          getValue: getPatientRecordNumber,
          x: 161,
          y: 58.25,
          width: 36,
        },
        {
          name: 'Patient Phone',
          type: 'text',
          getValue: getPatientFullPhone,
          x: 35,
          y: 62.25,
          width: 45,
          normalize: normalize.phone,
          format: value => (value ? value.replace('+1 ', '') : ''),
        },
        {
          name: 'Alt Contact',
          type: 'text',
          x: 101,
          y: 62.25,
          width: 47,
        },
        {
          name: 'Patient Alt Phone',
          type: 'text',
          x: 162,
          y: 62.25,
          width: 35,
          normalize: normalize.phone,
          format: value => (value ? value.replace('+1 ', '') : ''),
        },
        {
          name: 'Diagnosis',
          type: 'text',
          getValue: getDiagnosisCode,
          x: 33,
          y: 71.25,
          width: 60,
        },
        {
          name: 'Surgery',
          type: 'text',
          x: 108,
          y: 71.25,
          width: 53,
        },
        {
          name: 'Physician Visit Date',
          type: 'text',
          x: 172,
          y: 71.25,
          width: 24,
          normalize: normalize.date,
        },
        {
          name: 'Physician Name',
          type: 'text',
          getValue: getPrescriberName,
          x: 33,
          y: 75.25,
          width: 60,
        },
        {
          name: 'Physician Phone',
          type: 'text',
          getValue: getPrescriberFullPhone,
          x: 108,
          y: 75.25,
          width: 53,
          normalize: normalize.phone,
          format: value => (value ? value.replace('+1 ', '') : ''),
        },
        {
          name: 'Physician Next Visit Date',
          type: 'text',
          x: 178,
          y: 75.25,
          width: 18,
          normalize: normalize.date,
        },
        {
          name: 'APPROPRIATE FOR HOME',
          type: 'radio',
          options: [
            {
              x: 63.25,
              y: 89,
              width: 3,
              height: 3,
              value: 'Yes',
            },
            {
              x: 80,
              y: 89,
              width: 3,
              height: 3,
              value: 'No',
            },
          ],
        },
        {
          name: 'Alert & Understands',
          type: 'checkbox',
          x: 33,
          y: 93.5,
          width: 3,
          height: 3,
        },
        {
          name: 'Confused',
          type: 'checkbox',
          x: 33,
          y: 97.25,
          width: 3,
          height: 3,
        },
        {
          name: 'If Confused, Caregiver was instructed',
          type: 'text',
          x: 130,
          y: 97.25,
          width: 36,
        },
        {
          name: 'Uncluttered Passageways',
          type: 'radio',
          options: [
            {
              x: 68.5,
              y: 106,
              width: 3,
              height: 3,
              value: 'Yes',
            },
            {
              x: 85.25,
              y: 106,
              width: 3,
              height: 3,
              value: 'No',
            },
          ],
        },
        {
          name: 'Safe Operating Environment',
          type: 'radio',
          options: [
            {
              x: 68.5,
              y: 110,
              width: 3,
              height: 3,
              value: 'Yes',
            },
            {
              x: 85.25,
              y: 110,
              width: 3,
              height: 3,
              value: 'No',
            },
          ],
        },
        {
          name: 'Safe Operating Equipment',
          type: 'radio',
          options: [
            {
              x: 68.5,
              y: 114,
              width: 3,
              height: 3,
              value: 'Yes',
            },
            {
              x: 85,
              y: 114,
              width: 3,
              height: 3,
              value: 'No',
            },
          ],
        },
        {
          name: 'Equipment Alarms & Indicators',
          type: 'radio',
          options: [
            {
              x: 68.5,
              y: 118,
              width: 3,
              height: 3,
              value: 'Yes',
            },
            {
              x: 85.25,
              y: 118,
              width: 3,
              height: 3,
              value: 'No',
            },
          ],
        },
        {
          name: 'Other Home Care Services',
          type: 'checkbox',
          x: 19.5,
          y: 122.5,
          width: 3,
          height: 3,
        },
        {
          name: 'Other Home Care Services text',
          type: 'text',
          x: 58,
          y: 121,
          width: 50,
        },
        {
          name: 'Patient Smokes',
          type: 'radio',
          options: [
            {
              x: 167,
              y: 106,
              width: 3,
              height: 3,
              value: 'Yes',
            },
            {
              x: 178.5,
              y: 106,
              width: 3,
              height: 3,
              value: 'No',
            },
          ],
        },
        {
          name: 'Smoke Alarm & No Smoking Sign In Place',
          type: 'radio',
          options: [
            {
              x: 167,
              y: 110,
              width: 3,
              height: 3,
              value: 'Yes',
            },
            {
              x: 178.5,
              y: 110,
              width: 3,
              height: 3,
              value: 'No',
            },
          ],
        },
        {
          name: 'Advised of Electrical Requirements',
          type: 'radio',
          options: [
            {
              x: 167,
              y: 114,
              width: 3,
              height: 3,
              value: 'Yes',
            },
            {
              x: 178.5,
              y: 114,
              width: 3,
              height: 3,
              value: 'No',
            },
          ],
        },
        {
          name: 'Adapter Utilized',
          type: 'radio',
          options: [
            {
              x: 167,
              y: 118,
              width: 3,
              height: 3,
              value: 'Yes',
            },
            {
              x: 178.5,
              y: 118,
              width: 3,
              height: 3,
              value: 'No',
            },
          ],
        },
        {
          name: 'Fire Extinguisher',
          type: 'radio',
          options: [
            {
              x: 167,
              y: 122,
              width: 3,
              height: 3,
              value: 'Yes',
            },
            {
              x: 178.5,
              y: 122,
              width: 3,
              height: 3,
              value: 'No',
            },
          ],
        },
        {
          name: 'Oxygen Rx',
          type: 'text',
          x: 38,
          y: 134.5,
          width: 47,
        },
        {
          name: 'Oxygen Liters/Mins',
          type: 'text',
          x: 102,
          y: 134.5,
          width: 15,
        },
        {
          name: 'Oxygen Batch/Serial',
          type: 'text',
          x: 136,
          y: 134.5,
          width: 25,
        },
        {
          name: 'Oxygen Lot',
          type: 'text',
          x: 173,
          y: 134.5,
          width: 24,
        },
        {
          name: 'Oxygen Concentrator',
          type: 'checkbox',
          x: 29.5,
          y: 139.25,
          width: 3,
          height: 3,
        },
        {
          name: 'Oxygen Back-up system in place',
          type: 'checkbox',
          x: 59.25,
          y: 139.25,
          width: 3,
          height: 3,
        },
        {
          name: 'Oxygen Liquids',
          type: 'checkbox',
          x: 29.5,
          y: 143.25,
          width: 3,
          height: 3,
        },
        {
          name: 'Oxygen Cylinders',
          type: 'checkbox',
          x: 29.5,
          y: 147.25,
          width: 3,
          height: 3,
        },
        {
          name: 'Oxygen Cylinders С',
          type: 'text',
          x: 45,
          y: 146.5,
          width: 7,
        },
        {
          name: 'Oxygen Cylinders D',
          type: 'text',
          x: 57,
          y: 146.5,
          width: 7,
        },
        {
          name: 'Oxygen Cylinders E',
          type: 'text',
          x: 68,
          y: 146.5,
          width: 6,
        },
        {
          name: 'Oxygen Cylinders Other',
          type: 'text',
          x: 79.5,
          y: 146.5,
          width: 6,
        },
        {
          name: 'Nebulizer Med',
          type: 'text',
          x: 116.5,
          y: 142.5,
          width: 32,
        },
        {
          name: 'IPPB Press',
          type: 'text',
          x: 166.5,
          y: 142.5,
          width: 30,
        },
        {
          name: 'Nebulizer Times/Day',
          type: 'text',
          x: 116.5,
          y: 146.25,
          width: 32,
        },
        {
          name: 'IPPB Times/Day',
          type: 'text',
          x: 172.5,
          y: 146.25,
          width: 24,
        },
        {
          name: 'CPAP/BIPAP Unit',
          type: 'text',
          x: 32.5,
          y: 154.25,
          width: 25,
        },
        {
          name: 'CPAP/BIPAP IPAP',
          type: 'text',
          x: 68,
          y: 154.25,
          width: 25,
        },
        {
          name: 'CPAP/BIPAP Pressure',
          type: 'text',
          x: 32.5,
          y: 158.25,
          width: 25,
        },
        {
          name: 'CPAP/BIPAP EPAP',
          type: 'text',
          x: 68,
          y: 158.25,
          width: 25,
        },
        {
          name: 'CPAP/BIPAP Mask SRE',
          type: 'text',
          x: 32.5,
          y: 162.25,
          width: 25,
        },
        {
          name: 'CPAP/BIPAP Usage',
          type: 'text',
          x: 68,
          y: 162.25,
          width: 25,
        },
        {
          name: 'CPAP/BIPAP Nasal Pillows/Seals',
          type: 'text',
          x: 43.5,
          y: 166,
          width: 50,
        },
        {
          name: 'EQUIPMENT SETTINGS Other Line 1',
          type: 'text',
          x: 108.5,
          y: 154.25,
          width: 88,
        },
        {
          name: 'EQUIPMENT SETTINGS Other Line 2',
          type: 'text',
          x: 108.5,
          y: 158.25,
          width: 88,
        },
        {
          name: 'EQUIPMENT SETTINGS Other Line 3',
          type: 'text',
          x: 108.5,
          y: 162.25,
          width: 88,
        },
        {
          name: 'EQUIPMENT SETTINGS Other Line 4',
          type: 'text',
          x: 108.5,
          y: 166,
          width: 88,
        },
        {
          name: 'Rights & Responsibilities',
          type: 'checkbox',
          x: 29,
          y: 179.75,
          width: 2,
          height: 2,
        },
        {
          name: 'Service Availability of Company',
          type: 'checkbox',
          x: 29,
          y: 183.75,
          width: 2,
          height: 2,
        },
        {
          name: 'Privacy Notice',
          type: 'checkbox',
          x: 29,
          y: 187.5,
          width: 2,
          height: 2,
        },
        {
          name: '30 Medicare Supplier Standards',
          type: 'checkbox',
          x: 29,
          y: 191.5,
          width: 2,
          height: 2,
        },
        {
          name: 'Equipment Instructions',
          type: 'checkbox',
          x: 81.5,
          y: 179.75,
          width: 2,
          height: 2,
        },
        {
          name: 'Lease/Purchase Agreement',
          type: 'checkbox',
          x: 81.5,
          y: 183.75,
          width: 2,
          height: 2,
        },
        {
          name: 'Cleaning & Maintenance of Equipment',
          type: 'checkbox',
          x: 81.5,
          y: 187.5,
          width: 2,
          height: 2,
        },
        {
          name: 'Infection Control Tips',
          type: 'checkbox',
          x: 81.5,
          y: 191.5,
          width: 2,
          height: 2,
        },
        {
          name: 'Complaint process (reviewed/resolved)',
          type: 'checkbox',
          x: 139,
          y: 179.75,
          width: 2,
          height: 2,
        },
        {
          name: 'Follow-up & discharge instructions',
          type: 'checkbox',
          x: 139,
          y: 183.75,
          width: 2,
          height: 2,
        },
        {
          name: 'Warranty Form',
          type: 'checkbox',
          x: 139,
          y: 187.5,
          width: 2,
          height: 2,
        },
        {
          name: 'AOB Signature',
          type: 'checkbox',
          x: 139,
          y: 191.5,
          width: 2,
          height: 2,
        },
        {
          name: 'ADDITIONAL NOTES NEED 1',
          type: 'text',
          x: 18,
          y: 206.5,
          width: 60,
        },
        {
          name: 'ADDITIONAL NOTES GOAL 1',
          type: 'text',
          x: 80,
          y: 206.5,
          width: 54,
        },
        {
          name: 'ADDITIONAL NOTES RESULTS 1',
          type: 'text',
          x: 136,
          y: 206.5,
          width: 61,
        },
        {
          name: 'ADDITIONAL NOTES NEED 2',
          type: 'text',
          x: 18,
          y: 210.75,
          width: 60,
        },
        {
          name: 'ADDITIONAL NOTES GOAL 2',
          type: 'text',
          x: 80,
          y: 210.75,
          width: 54,
        },
        {
          name: 'ADDITIONAL NOTES RESULTS 2',
          type: 'text',
          x: 136,
          y: 210.75,
          width: 61,
        },
        {
          name: 'Follow-Up Visit Recommended',
          type: 'checkbox',
          x: 64.5,
          y: 221.25,
          width: 2,
          height: 2,
        },
        {
          name: 'Follow-Up Visit Recommended Line 1',
          type: 'text',
          x: 69,
          y: 219.5,
          width: 33,
        },
        {
          name: 'Follow-Up Visit Recommended Line 2',
          type: 'text',
          x: 69,
          y: 223.25,
          width: 33,
        },
        {
          name: 'Follow-Up by Phone & As Needed',
          type: 'checkbox',
          x: 157,
          y: 221.25,
          width: 2,
          height: 2,
        },
        {
          name: 'Next Dr. Visit',
          type: 'text',
          x: 39,
          y: 227.75,
          width: 69,
        },
        {
          name: 'Equip To be P/U',
          type: 'text',
          x: 136,
          y: 227,
          width: 61,
        },
        {
          name: 'Name of authorized person',
          type: 'text',
          x: 125,
          y: 231,
          width: 72.5,
        },
        {
          name: 'Signature of Rep',
          type: 'signature',
          x: 54,
          y: 237,
          width: 60,
          height: 8,
        },
        {
          name: 'Authorized person Relationship',
          type: 'text',
          x: 144,
          y: 239,
          width: 52,
        },
        {
          name: 'Signature of Patient',
          type: 'signature',
          getValue: getSignature,
          x: 54,
          y: 250,
          width: 60,
          height: 8,
        },
        {
          name: 'Authorized person Date',
          type: 'text',
          getValue: getSignatureDate,
          x: 144,
          y: 251.5,
          width: 52,
          normalize: normalize.date,
        },
      ],
    },
  ],
};

export default DeliveryTicketPlanOfCareRespiratory;



// WEBPACK FOOTER //
// ./src/config/documents/Delivery-Ticket-Plan-Of-Care-Respiratory.js